import {useCallback} from 'react';

import {EVENT_NAMES} from '/enum/tealium.enum';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {getReportName} from '../util/myTeamsAnalytics.util';

import {useMyTeamsContext} from './useMyTeamsContext';

type Props = {
  effectiveLastPaidRank?: string;
  effectiveHighestAchievedRank?: string;
  effectiveCoachCurrentRank?: string;
  effectiveUserId?: string | number;
};

export const useMyTeamsAnalytics = ({
  effectiveLastPaidRank,
  effectiveHighestAchievedRank,
  effectiveCoachCurrentRank,
  effectiveUserId,
}: Props) => {
  const {reduxActiveTab, reduxIsViewTeam} = useMyTeamsContext();

  const trackTeamSearch = useCallback(() => {
    const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
      eventName: EVENT_NAMES.searchTeamorg,
    });

    const screenName = getReportName(reduxIsViewTeam, reduxActiveTab);

    sendEvent({
      screenName,
      lastPaidRank: effectiveLastPaidRank,
      coachHighestRank: effectiveHighestAchievedRank,
      coachCurrentRank: effectiveCoachCurrentRank,
      coachID: String(effectiveUserId ?? ''),
    });
  }, [
    reduxIsViewTeam,
    reduxActiveTab,
    effectiveLastPaidRank,
    effectiveHighestAchievedRank,
    effectiveCoachCurrentRank,
    effectiveUserId,
  ]);

  return {trackTeamSearch};
};
